<mat-menu #streamsMenu>
  @for (stream of streams; track streamIdentity(stream)) {
    <a mat-menu-item routerLink="/live/streams/{{stream.id}}">
      @if (stream.active_live_event?.show) {
        [{{stream.active_live_event.show.name}}]
      }
      {{stream.title || stream.active_live_event?.title}}
    </a>
  }
</mat-menu>
@if (!stream) {
  <app-spinner></app-spinner>
}
@if (stream) {
  @if (showMoreStreams) {
    <div class="more-streams">
      <div class="actions">
        <h2>Active Live Streams</h2>
        <div class="spacer"></div>
        <button mat-raised-button color="primary" (click)="refresh()" [disabled]="!this.streams || refreshDisallowed">
          <mat-icon>{{ refreshing ? 'sync' : refreshDisallowed ? 'check' : 'sync' }}</mat-icon>
          {{ refreshing ? 'Refreshing...' : refreshDisallowed ? 'Refreshed' : 'Refresh' }}
        </button>
        <button mat-icon-button (click)="showMoreStreams = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      @if (!streams) {
        <div class="loading-state">
          <app-spinner class="inline"></app-spinner>
        </div>
      }
      @if (streams && stream) {
        @for (otherStream of streams; track otherStream) {
          @if (shouldOfferStream(otherStream)) {
            <div class="stream" [class.current]="otherStream.id === stream.id">
              <div class="title">
                <h3>
                  {{otherStream.title || otherStream.active_live_event?.title}}
                  @if (otherStream.persistent) {
                    <span class="tag">24/7</span>
                  }
                </h3>
                <div class="spacer"></div>
                <div class="actions">
                  @if (stream.id !== otherStream.id) {
                    <a mat-menu-item routerLink="/live/streams/{{otherStream.id}}">
                      <mat-icon>play_arrow</mat-icon>
                      Watch Now
                    </a>
                  }
                </div>
              </div>
              <div class="meta">
                <tyt-content-badge [premium]="otherStream.premium" type="live"></tyt-content-badge>
                <tyt-tag class="event">
                  <div class="label">
                    Started:
                  </div>
                  <tyt-timestamp [value]="otherStream.started"></tyt-timestamp>
                </tyt-tag>
                @if (otherStream.active_live_event) {
                  <tyt-tag class="event">
                    Now Playing: {{otherStream.active_live_event.show?.name || otherStream.active_live_event.title }}
                  </tyt-tag>
                }
                @if (getUpcomingEvents(otherStream).length > 0) {
                  <tyt-tag class="event">
                    Coming Up:
                    <span class="event-instances">
                      @for (event of getUpcomingEvents(otherStream); track event) {
                        <span class="event-instance">
                          {{event.show?.name || event.title}}
                        </span>
                      }
                    </span>
                  </tyt-tag>
                }
                @if (getUpcomingEvents(otherStream).length === 0) {
                  <tyt-tag class="event">
                    This is the last event of the stream
                  </tyt-tag>
                }
              </div>
            </div>
          }
        }
      }
    </div>
  }
  <div class="current-event title-block">
    <div class="title">
      <div class="stream-status">
        @if (stream.finished == null) {
          <div class="live-button">
            <tyt-live-tag></tyt-live-tag>
          </div>
        }
        @if (stream.finished != null) {
          <div class="ended-button">
            <span>Ended</span>
          </div>
        }
      </div>
      <h1>{{stream.title || stream.active_live_event?.title}}</h1>

      @if (stream.persistent) {
        Live 24/7
      }

      <div class="spacer"></div>
      <div class="stream-meta">
        @if (stream.premium) {
          <tyt-plus-tag text="Members Only Stream" matTooltip="You are watching the members only stream."></tyt-plus-tag>
        }
        @if (!stream.premium) {
          <tyt-tag>Public Stream</tyt-tag>
        }
        @if (!showMoreStreams) {
          <a mat-button (click)="showMoreStreams = true">More Streams</a>
        }
        <a mat-button routerLink="/live/schedule">Schedule</a>

        @if (showDevTools) {
          <div class="devtools">
            <mat-menu #devMenu>
              <button mat-menu-item (click)="devSendToAppPlayer()">
                <mat-icon>south_east</mat-icon>
                Send to App Player
              </button>

              <mat-divider></mat-divider>

              @if (simulation) {
                <a mat-menu-item routerLink="/engineering/live-streams/simulations">
                  <mat-icon>science</mat-icon>
                  Simulations
                </a>
                <button mat-menu-item (click)="devStopSimulation()">
                  <mat-icon>stop</mat-icon>
                  Stop Simulation
                </button>
                <button mat-menu-item (click)="devRestartSimulation()">
                  <mat-icon>refresh</mat-icon>
                  Restart Simulation
                </button>
              } @else {
                <a mat-menu-item routerLink="/engineering/live-streams/simulations">
                  <mat-icon>science</mat-icon>
                  Simulate
                </a>
              }
            </mat-menu>

            <button mat-button [matMenuTriggerFor]="devMenu">
              <mat-icon>code</mat-icon> Dev
            </button>

            @if (simulation) {
              <a class="simulation-tag" matTooltip="A live streaming simulation is currently active and controlling the state of the current live streams." routerLink="/engineering/live-streams/simulations/{{ simulation.spec.id }}" class="simulation-tag">
                <mat-icon>science</mat-icon>
                {{ simulation.spec.label }}
              </a>
            }
          </div>
        }

      </div>
    </div>
  </div>
  <div class="schedule-block">
    <div class="player" [class.has-paywall]="paywallVisible">
      @if (technicalDifficulties) {
        <div class="technical-difficulties">
          <div class="image">
            <img src="/assets/mariguana.png" />
          </div>
          <div class="details">
            We're working on restoring the live stream.<br />
            Back shortly, please stand by!<br />
            @if (technicalDifficultiesTimeBeforeTryAgain > 0) {
              <div style="margin-top: 1em; font-size: 75%;">
                <span class="no-mobile">
                  <br />
                  Help keep TYT.com up and running by <strong style="color: yellow; font-size: 110%">refraining from
                excessive page reloads</strong>
                while you wait for the issue to be resolved.<br />
                <br />
                <br />
              </span>
              <a href="javascript:;" style="opacity: 0.6; cursor: not-allowed;">Try again in
              {{technicalDifficultiesTimeBeforeTryAgain}} seconds</a>
            </div>
          }
          @if (technicalDifficultiesTimeBeforeTryAgain <= 0) {
            <a href="javascript:window.location.reload();">Try
            again</a>
          }
        </div>
      </div>
    }
    @if (!technicalDifficulties) {
      <tyt-media-player
        #player
        [isLive]="!stream.finished"
        [inline]="true"
        [autoSwitchLive]="false"
        (newLiveStreamAvailable)="switchToNewLiveStream($event)"
        (newSession)="session = $event"
        (paywallVisible)="paywallVisible = $event"
        (newChatEmbed)="platformChat = $event"
        [additionalMenuItems]="additionalMenuItems"
        />
    }
  </div>
  <div class="current-event">
    @if (stream && stream.finished != null) {
      <div class="info-note">
        <h1>This stream has ended</h1>
        <p>Not all of our live streams can be replayed after they are completed. Please check out our <a
        routerLink="/live/schedule">Live Schedule</a>
      to see when you can catch our next show!</p>
      <div style="text-align: right;">
        <a routerLink="/" mat-raised-button color="primary" >Go Home</a>
      </div>
    </div>
  }
  @if (stream && actionableUpgradeStream) {
    <div class="info-note">
      <a class="close" href="javascript:;" (click)="actionableUpgradeStream = null">
        <mat-icon>close</mat-icon>
      </a>
      @if (freeStreamPrompt == 'unentitled') {
        <h1>This stream is free</h1>
        <p>...but there's more of it if you <a href="{{joinUrl}}">become a TYT member!</a></p>
        TYT members can:
        <ul>
          <li>Watch all parts of today's show uninterrupted</li>
          <li>Post comments on this show and any content you find on TYT.com</li>
          <li>Enjoy members-only chat</li>
        </ul>
      }
      @if (freeStreamPrompt == 'anonymous') {
        <h1>Are you a member?</h1>
        <p>This live event has streams for both members and non-members,
          and you are currently watching the <strong>non-members version</strong> because you are not logged in.</p>
          <p><a routerLink="/login">Login</a> with your TYT membership or <a href="{{joinUrl}}">sign up now</a>!</p>
          TYT members can:
          <ul>
            <li>Watch all parts of today's show uninterrupted</li>
            <li>Post comments on this show and any content you find on TYT.com</li>
            <li>Enjoy members-only chat</li>
          </ul>
        }
        @if (freeStreamPrompt == 'entitled') {
          <h1>Hello TYT Member!</h1>
          <p>Looking for the members-only live stream? You are watching the free, public
          stream of this event, but a members-only stream is available! </p>
          <p>Did you know? You can watch all public portions of the show from the members-only stream,
          so that you don't have to switch when the members-only portion starts!</p>
          <a routerLink="/live/streams/{{upgradeStream.id}}">Click here to go the members-only version!</a>
        }
      </div>
    }
  </div>
  <div class="bottom-area">
    @if (showComments) {
      <div class="main-column">
        <tyt-staging-note title="Comment Topic" [shown]="true">
          <code>{{ topicIdentifier }}</code>
        </tyt-staging-note>

        <tyt-comments
          [url]="urlForStream(stream)"
          [identifier]="topicIdentifier"
          [shareTitle]="topicTitle"
          [handleNotifications]="!playerIsFullScreen"
          [maxVisibleMessages]="200"
          defaultSortOrder="newest"
        ></tyt-comments>
      </div>
    }
    <div class="secondary-column">
      <div class="sub-sidebar">
        <div class="chat-embed-container">
          @if (!stream.premium && upgradeStream) {
            <div class="chat-header">Members-Only Chat</div>
            <div class="info-note">
              <a href="{{joinUrl}}">Join TYT</a> to chat on the <a
            routerLink="/live/streams/{{upgradeStream.id}}">members-only live stream</a>. *
            <br />
            <br />
            <small>
              * Requires a Google account.<br />
              &nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:;" (click)="showChatNotes = true">Learn More</a>
            </small>
          </div>
        }
        @if (showChat && (useBantaChat || platformChat) && stream.premium) {
          <div class="chat-header">Members-Only Chat</div>
          <tyt-live-chat
            [stream]="stream"
            [platformChatEmbed]="platformChat"
          ></tyt-live-chat>
          @if (platformChat) {
            <em style="font-size: 80%;">
              Note: Participating in YouTube chat requires a Google account.
              <a href="javascript:;" (click)="showChatNotes = true">Learn More</a><br />
            </em>
            @if (showChatNotes) {
              <div>
                <ul>
                  <li>
                    <strong>I don't want to use my real name</strong><br />
                    If you are not comfortable chatting with a real Google account identity, YouTube supports <a
                    target="_blank" href="https://support.google.com/youtube/answer/2897336?hl=en">brand
                  accounts</a> which allow you to chat under a pseudonym.
                  In the future you will only need your TYT account!<br />
                </li>
              </ul>
            </div>
          }
        }
      }
      <br />
      <br />
    </div>
    @if (showDonatePromos && showComments) {
      <div class="donate-promo-container">
        <a class="close" href="javascript:;" (click)="showDonatePromos = false">
          <mat-icon>close</mat-icon>
        </a>
        <a class="donate-promo" href="https://secure.actblue.com/donate/tytnetwork" target="_blank">
          <div>
            <img src="/assets/yes-button-baked.svg" />
            Help TYT continue producing truly independent journalism
          </div>
        </a>
      </div>
    }
    @if (stream.live_events && stream.live_events.length > 0) {
      <tyt-feed-tag>Events in this stream</tyt-feed-tag>
      @for (item of stream.live_events; track item) {
        <div class="schedule-item">
          <div class="avatar" [responsiveBackgroundImage]="item.show.logo_square"></div>
          <div class="spacer">
            <h2>
              @if (item) {
                {{item.show.name}}
              }
            </h2>
            @if (item.is_premium) {
              <tyt-plus-tag></tyt-plus-tag>
            }
          </div>
          @if (stream.active_live_event && stream.active_live_event.id == item.id) {
            <div class="watch">
              <tyt-live-tag></tyt-live-tag>
            </div>
          }
          @if (!stream.active_live_event || stream.active_live_event.id != item.id) {
            <div class="time">
              {{airTimeForItem(item) | date : 'h:mm a'}} {{timezoneString}}
            </div>
          }
        </div>
      }
    }
  </div>
</div>
</div>
</div>
}

<tyt-staging-note title="Developer Tools" [shown]="true">
  <a href="javascript:;" (click)="devShowUpgrade()">Members-Only Upgrade</a>
</tyt-staging-note>

<tyt-staging-note title="Live Stream (JSON)" [shown]="false">
  <tyt-json-view [value]="stream"></tyt-json-view>
</tyt-staging-note>